import { action, makeObservable, observable, reaction } from 'mobx';
import { popupStore } from '../../../store/popupStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { KeyA, KeyS, Space } from '../../../core/constants/hotKeys';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { footballGameService } from '../footballService/gameService';
import { footballBetsStore } from './betStore';
import { freeBetStore } from '../../../store/freeBetStore';

class FootballHotKeysStore {
  isStartHotKeys = false;

  isAllowUseHotKeys = true;

  isSpaceHeld = false;

  hotKeysActions = {
    [Space]: () => {
      if (
        !footballBetsStore.isHeldButton &&
        userInfoStore.betAmount &&
        !footballBetsStore.isBetsClosed
      ) {
        footballBetsStore.setIsHeldButton(true);
        footballGameService.doSpin();
      }
    },
    [KeyA]: () => {
      const { currentFreeBet } = freeBetStore;
      if (!footballBetsStore.isHeldButton && !footballBetsStore.isBetsClosed && !currentFreeBet) {
        userInfoStore.setHalve();
      }
    },
    [KeyS]: () => {
      const { currentFreeBet } = freeBetStore;
      if (!footballBetsStore.isHeldButton && !footballBetsStore.isBetsClosed && !currentFreeBet) {
        userInfoStore.setDouble();
      }
    },
  };

  constructor() {
    this.boundHandleKeyDown = this.handleKeyDown.bind(this);
    this.boundHandleKeyUp = this.handleKeyUp.bind(this);
    makeObservable(this, {
      isSpaceHeld: observable,
      isStartHotKeys: observable,
      isAllowUseHotKeys: observable,
      handleKeyDown: action.bound,
      setIsSpaceHeld: action.bound,
      setIsStartHotKeys: action.bound,
    });
    reaction(
      () => userInfoStore.betAmount,
      (value) => {
        this.isAllowUseHotKeys =
          value >= userInfoStore.limits.minBet && value <= userInfoStore.limits.maxBet;
      }
    );
  }

  setIsSpaceHeld(value) {
    this.isSpaceHeld = value;
  }

  handleKeyDown(e) {
    if (e.code === Space) {
      this.setIsSpaceHeld(true);
      e.preventDefault();
    }
    if (!popupStore.isOpenPopup && this.isAllowUseHotKeys) {
      if (this.hotKeysActions[e.code]) {
        this.hotKeysActions[e.code]();
      }
    }
  }

  handleKeyUp(e) {
    if (e.code === Space) {
      footballBetsStore.setIsHeldButton(false);
      this.setIsSpaceHeld(false); // doesn't work with this
      footballGameService.sendCashOut();
      footballGameService.cancelInvoke();
    }
  }

  setIsStartHotKeys(checked) {
    this.isStartHotKeys = checked;
    userSettingsStore.setIsHotKeyEnable(checked);
    if (checked) {
      window.addEventListener('keydown', this.boundHandleKeyDown);
      window.addEventListener('keyup', this.boundHandleKeyUp);
    } else {
      window.removeEventListener('keydown', this.boundHandleKeyDown);
      window.removeEventListener('keyup', this.boundHandleKeyUp);
    }
  }
}

export const footballHotKeysStore = new FootballHotKeysStore();
